/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Buy-side title-clearance state for the PRE_CLOSING_CHECKIN task.
 * 
 * Persisted as a lowercase string in ``transactions.title_clearance_status``
 * (``String(20)``, not a Postgres enum type, to keep migrations simple).
 * New transactions logically default to ``PENDING`` at the API layer; the
 * DB column itself is nullable so already-migrated rows remain empty.
 * @export
 */
export const TitleClearanceStatus = {
    Clear: 'clear',
    Pending: 'pending',
    Blocked: 'blocked'
} as const;
export type TitleClearanceStatus = typeof TitleClearanceStatus[keyof typeof TitleClearanceStatus];


export function TitleClearanceStatusFromJSON(json: any): TitleClearanceStatus {
    return TitleClearanceStatusFromJSONTyped(json, false);
}

export function TitleClearanceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TitleClearanceStatus {
    return json as TitleClearanceStatus;
}

export function TitleClearanceStatusToJSON(value?: TitleClearanceStatus | null): any {
    return value as any;
}

